import _Form from './Form';

import './style/index.js';

export type { FormProps } from './Form';
export type { FormItemProps } from './FormItem';
export * from './type';

export const Form = _Form;
export default Form;
